import * as React from 'react';
import moment from 'moment-timezone';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './startDateSummary.module.scss';

const EmptyBox = () => (
    <div styleName="empty-box">
        カレンダーから開始する日を<br />
        選択してください
    </div>
);

const DefaultBox = ({ title, children, onSubmit, label }) => (
    <div styleName="box">
        <div styleName="title">{title}</div>
        <div styleName="body">{children}</div>
        <div styleName="button-wrapper">
            <Button id="default-box-submit" styleName="button" type="primary" size="ms" onClick={onSubmit}>
                {label}
            </Button>
        </div>
    </div>
);

export const StartDateSummary = ({ date, onSubmit, label = undefined }) => {
    if (!date) {
        return <EmptyBox />;
    }
    return (
        <DefaultBox
            title="留意事項"
            onSubmit={date ? onSubmit : undefined}
            label={label ? label : 'ホーム拠点の選択へ'}
        >
            ・受講開始日が今後の課金更新日となります<br />
            ・開始日以前は、コースの視聴や各イベントの参加はできません<br />
            ・開始日以降に開催される各イベントへの事前予約は可能です
        </DefaultBox>
    );
};
